import React from "react";
import { Route, Routes as ReactRoutes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import flattenDeep from "lodash/flattenDeep";

const generateFlattenRoutes = (routes: any) => {
  if (!routes) return [];
  return flattenDeep(
    routes.map(({ routes, ...rest }: any) => [
      rest,
      generateFlattenRoutes(routes),
    ])
  );
};

export const renderRoutes = (mainRoutes: any) => {
  const Routes = ({ isAuthorized }: any) => {
    const layouts = mainRoutes.map(
      ({ layout: Layout, routes }: any, index: any) => {
        const subRoutes = generateFlattenRoutes(routes);

        return (
          <Route key={index} element={<Layout />}>
            <Route element={<ProtectedRoute isAuthorized={isAuthorized} isPrivate={
                location.pathname === "/ad-insert-step-one" ||
                location.pathname === "/ad-insert-step-two" ||
                location.pathname === "/ad-insert-step-three" ||
                location.pathname === "/user-profile" ||
                location.pathname === "/notification" ||
                location.pathname === "/bookmark-list" ||
                location.pathname === "/user-products" ||
                location.pathname === "/location"
            }/>}>
              {subRoutes.map(({ component: Component, path, name }: any) => {
                return (
                  Component &&
                  path && (
                    <Route key={name} element={<Component />} path={path} />
                  )
                );
              })}
            </Route>
          </Route>
        );
      }
    );
    return <ReactRoutes>{layouts}</ReactRoutes>;
  };
  return Routes;
};
